import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const { surveyType } = CommonParameters;

export const Survey: IMcAppType = {
  name: "survey",
  path: "/my/survey",
  parameters: {
    properties: { surveyType },
  },
  description: "Task completion survey",
  navFlow: NavFlow.MODAL,
  title: "",
  parent: Tab.DASHBOARD, // Changed from Tab.MORE, Temporary workaround due to navigation issues on Mobile. See https://origindd.atlassian.net/browse/P21-2410

  conditions: {
    intent: "survey",
    customerType: CustomerType.kraken,
  },
};
